import { createContext } from "react";

export const CodeLegendContext = createContext({
  codeLegends: [],
  masterEntries: [],
  refreshCodeLegendContext: async () => {},
});
